module.exports = __webpack_public_path__ + "static/media/all1.60eadac6.jpg";